import { render, staticRenderFns } from "./DetailsStaticDataField.vue?vue&type=template&id=57d90441&scoped=true"
import script from "./DetailsStaticDataField.vue?vue&type=script&lang=ts"
export * from "./DetailsStaticDataField.vue?vue&type=script&lang=ts"
import style0 from "./DetailsStaticDataField.vue?vue&type=style&index=0&id=57d90441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d90441",
  null
  
)

export default component.exports